module.exports = __webpack_public_path__ + "img/calculator.daf6762f.png";